/** `CODE` or `CODE:ARG` → `{ code, arg? }` (the first colon splits; the argument keeps any further colon). */
export function splitReason(reason) {
    const at = reason.indexOf(':');
    return at < 0 ? { code: reason } : { code: reason.slice(0, at), arg: reason.slice(at + 1) };
}
export function splitReasons(reasons) {
    return reasons.map(splitReason);
}
/**
 * The catalog vocabulary that translates the ARGUMENT of a code family. An onboarding item is a closed list (`driver.onboarding_item`);
 * a DOCUMENT type is data of the market's KYC catalog (a country adds its own), so it carries no fixed vocabulary — the screen
 * reads the type's name from the catalog entry it already loads.
 */
export const REASON_ARG_VOCABULARIES = {
    ONBOARDING: 'driver.onboarding_item',
};
//# sourceMappingURL=reason-parts.js.map